<div class="review-modal text-center p-4 position-relative text-muted">
  <button
    type="button"
    class="btn-close position-absolute top-0 end-0 m-3 f-10"
    aria-label="Close"
    (click)="closeDialog('close')"
  ></button>

  <div class="mb-3 mt-2">
    <img
      src="https://res.cloudinary.com/pervolare-org/image/upload/v1761699125/TAS/rutt/alert-triangle_xaxcef.png"
      alt="icon"
    />
  </div>

  <h5 class="fw-bold mb-3">Resumen de Solicitud de Reembolso</h5>

  <p class="mb-4 f-16">
    Documentos adjuntos:
    <span class="fw-bold">({{ datosDocumentos.pasaportes }})</span> Pasaportes,
    <span class="fw-bold">({{ datosDocumentos.facturas }})</span> Facturas,
    @if (datosDocumentos.informesMedicos > 0) {
      <span
        ><span class="fw-bold">({{ datosDocumentos.informesMedicos }})</span>
        Informes Médicos,</span
      >
    }
    @if (datosDocumentos.recetasMedicas > 0) {
      <span
        ><span class="fw-bold">({{ datosDocumentos.recetasMedicas }})</span>
        Recetas Médicas,</span
      >
    }
    @if (datosDocumentos.soportes > 0) {
      <span
        ><span class="fw-bold">({{ datosDocumentos.soportes }})</span>
        Soportes,</span
      >
    }
    <span class="fw-bold">({{ datosDocumentos.otros }})</span> Otros documentos
  </p>

  <p class="mb-4 f-16">
    <strong>¿Deseas modificar tu solicitud?</strong><br />
    Una vez enviado, no será posible ajustar o cambiar la solicitud y el
    formulario se cerrará.
  </p>

  <button class="btn btn-primary w-100 fw-bold" (click)="closeDialog('enviar')">
    Finalizar solicitud
  </button>
  <div class="mt-2">
    <a
      class="text-primary fw-medium"
      style="cursor: pointer"
      (click)="closeDialog('modificar')"
    >
      Modificar
    </a>
  </div>
</div>
